import { buildUrl, getStoreCode, getStoreUrl } from "../../config/selectors";
import { addPageSpecificSearchParams } from "./addPageSpecificSearchParams";

export const buildProduct = ({ product }, state) => ({
  ...product,
  url: addPageSpecificSearchParams({
    url: buildUrl(
      {
        storeUrl: getStoreUrl(state),
        storeCode: getStoreCode(state)
      },
      product.url
    ),
    state
  })
});
